import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import {
  PRODUCT_PURCHASE_OPTIONS,
  BATCH_RENEWAL_COMPONENT_CONTEXT,
  CADENCE_TYPE,
  checkBatchRenewal,
} from 'utils/subscriptions';
import BatchAndRenewalNotification from 'shared-components/BatchAndRenewalNotification/BatchAndRenewalNotification';
import styles from './SubscriptionSelector.module.scss';

const SubscriptionSelector = ({
  isOneTimePurchaseAvailable,
  isSubscriptionAvailable,
  hasActiveSubscription,
  productPurchaseOption,
  subscribableProducts,
  subscriptionPrice,
  subscriptionPercentOff,
  oneTimePrice,
  handleSubscribeChange,
}) => {
  const isOneTimePurchaseSelected =
    productPurchaseOption === PRODUCT_PURCHASE_OPTIONS.ONE_TIME;
  const isSubscribeAndSaveSelected =
    productPurchaseOption === PRODUCT_PURCHASE_OPTIONS.SAVE_SUBSCRIBE;
  const nextRenewalDateNinetyDays = checkBatchRenewal(
    subscribableProducts,
    CADENCE_TYPE.NINETY_DAYS
  );

  return (
    <div
      data-testid="subscription-selector-container"
      className={styles.subscriptionsContainer}
    >
      <label
        htmlFor="subscriptionOption-OneTime"
        data-testid="subscription-option-one-time-label"
        className={classNames(styles.subscriptionItem, {
          [styles.subscriptionItemDisabled]: !isOneTimePurchaseAvailable,
        })}
      >
        <div className={styles.subscriptionOption}>
          <input
            id="subscriptionOption-OneTime"
            data-testid="subscription-option-one-time"
            type="radio"
            name="subscriptionOption"
            value="oneTime"
            checked={isOneTimePurchaseSelected}
            onChange={handleSubscribeChange}
            aria-checked={isOneTimePurchaseSelected}
            data-dd-action-name="One-off product radio button"
          />
          <span className={styles.subscriptionName}>One-Time Purchase</span>
        </div>
        <span className={styles.subscriptionPrice}>{oneTimePrice}</span>
      </label>
      <label
        htmlFor="subscriptionOption-SubscribeSave"
        data-testid="subscription-option-subscribe-save-label"
        className={classNames(styles.subscriptionItem, {
          [styles.subscriptionItemDisabled]:
            !isSubscriptionAvailable || hasActiveSubscription,
        })}
      >
        <div className={styles.subscriptionOption}>
          <input
            id="subscriptionOption-SubscribeSave"
            data-testid="subscription-option-subscribe-save"
            type="radio"
            name="subscriptionOption"
            value="saveSubscribe"
            checked={isSubscribeAndSaveSelected}
            onChange={handleSubscribeChange}
            aria-checked={isSubscribeAndSaveSelected}
            data-dd-action-name="Subscription product radio button"
          />
          <span className={styles.subscriptionName}>Subscribe &amp; Save</span>
          {subscriptionPercentOff && (
            <span className={styles.subscriptionSave}>
              SAVE {subscriptionPercentOff}%
            </span>
          )}
        </div>
        <span className={styles.subscriptionPrice}>{subscriptionPrice}</span>
      </label>
      {isSubscriptionAvailable &&
        isSubscribeAndSaveSelected &&
        !nextRenewalDateNinetyDays && (
          <span className={styles.subscriptionFrequency}>
            Ships every 3 months
          </span>
        )}
      {isSubscriptionAvailable &&
        isSubscribeAndSaveSelected &&
        nextRenewalDateNinetyDays && (
          <BatchAndRenewalNotification
            shippingDate={nextRenewalDateNinetyDays}
            cadenceType={CADENCE_TYPE.NINETY_DAYS}
            context={BATCH_RENEWAL_COMPONENT_CONTEXT.accordion}
          />
        )}
    </div>
  );
};

SubscriptionSelector.propTypes = {
  isOneTimePurchaseAvailable: PropTypes.bool.isRequired,
  isSubscriptionAvailable: PropTypes.bool.isRequired,
  hasActiveSubscription: PropTypes.bool.isRequired,
  productPurchaseOption: PropTypes.string.isRequired,
  subscriptionPrice: PropTypes.string.isRequired,
  subscriptionPercentOff: PropTypes.number.isRequired,
  oneTimePrice: PropTypes.string.isRequired,
  subscribableProducts: PropTypes.shape({}).isRequired,
  handleSubscribeChange: PropTypes.func.isRequired,
};

export default SubscriptionSelector;
